import React from "react";
import Footer from "../../component/footer";
import "./Roadmap.css";
function Roadmap() {
  return (
    <>
      <section className="Roadmap-mainse">
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-12">
              <h1>Follow The</h1>
              <h2>Roadmap</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="Roadmap-timeline">
        <div className="container-1280">
          <div className="row time-row-1">
            <div className="col-lg-6">
              <h3>
                Gaming Arcade
                <br />
                <span>Roadmap</span>
              </h3>
            </div>
          </div>
          <div className="row time-row-2">
            <div className="col-lg-6">
              {/* <img src={require('../../Assets/img/left-time.png')} /> */}
              <span
                className="linear-gradient-sizing color-pink"
                data-aos="fade-left"
                data-aos-offset="250"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
              ></span>
              <span
                className="linear-gradient-sizing color-yellow"
                data-aos="fade-right"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="900"
              ></span>
            </div>
            <div
              className="col-lg-6"
              data-aos="fade-in"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
            >
              <div className="vs-div">
                <img
                  src={require("../../Assets/img/Vs-icon.png")}
                  alt="vs-icon"
                />
                <p>1 vs 1 games </p>
              </div>
            </div>
          </div>
          <div className="row time-row-3">
            <div
              className="col-lg-6"
              data-aos="fade-in"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
            >
              <div className="vs-main-div">
                <div className="vs-div">
                  <img
                    src={require("../../Assets/img/affiliate-marketing.png")}
                    alt="marketing"
                  />
                  <p>5 Stage Referral System</p>
                </div>
                <div className="vs-div">
                  <img
                    src={require("../../Assets/img/trophy (2).png")}
                    alt="trophy"
                  />
                  <p>Tournaments</p>
                </div>
                <div className="vs-div">
                  <img
                    src={require("../../Assets/img/winner.png")}
                    alt="winner"
                  />
                  <p>Open Challanges</p>
                </div>
                <div className="vs-div">
                  <img
                    src={require("../../Assets/img/game-controller.png")}
                    alt="controller"
                  />
                  <p>Practice Games</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              {/* <img src={require('../../Assets/img/right-time.png')} /> */}
              <span
                className="linear-gradient-sizing color-pink right-side"
                data-aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
              ></span>
              <span
                className="linear-gradient-sizing color-yellow right-side"
                data-aos="fade-right"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="900"
              ></span>
            </div>
          </div>
          <div className="row time-row-4">
            <div className="col-lg-6">
              {/* <img src={require('../../Assets/img/left-time.png')} /> */}
              <span
                className="linear-gradient-sizing color-pink"
                data-aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
              ></span>
              <span
                className="linear-gradient-sizing color-yellow"
                data-aos="fade-right"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="900"
              ></span>
            </div>
            <div
              className="col-lg-6"
              data-aos="fade-in"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
            >
              <div className="vs-main-div">
                <div className="vs-div">
                  <img
                    src={require("../../Assets/img/cryptocurrency-coins.png")}
                    alt="coins"
                  />
                  <p>Multi coin / Token games</p>
                </div>
                <div className="vs-div">
                  <img
                    src={require("../../Assets/img/nft-game.png")}
                    alt="nft-game"
                  />
                  <p>INO</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row time-row-5">
            <div
              className="col-lg-6"
              data-aos="fade-left"
              data-aos-offset="200"
              data-aos-easing="ease-in-sine"
              data-aos-duration="600"
            >
              <div className="vs-main-div">
                <div className="vs-div">
                  <img
                    src={require("../../Assets/img/cryptocurrency-coins.png")}
                    alt="coins"
                  />
                  <p>5 Stage Referral System</p>
                </div>
                <div className="vs-div">
                  <img
                    src={require("../../Assets/img/trophy (2).png")}
                    alt="trophy2"
                  />
                  <p>Tournaments</p>
                </div>
                <div className="vs-div">
                  <img
                    src={require("../../Assets/img/winner.png")}
                    alt="winner"
                  />
                  <p>Open Challanges</p>
                </div>
                <div className="vs-div">
                  <img
                    src={require("../../Assets/img/game-controller.png")}
                    alt="controller"
                  />
                  <p>Practice Games</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              {/* <img src={require('../../Assets/img/right-time.png')} /> */}
              <span
                className="linear-gradient-sizing color-pink right-side"
                data-aos="fade-left"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="600"
              ></span>
              <span
                className="linear-gradient-sizing color-yellow right-side"
                data-aos="fade-right"
                data-aos-offset="200"
                data-aos-easing="ease-in-sine"
                data-aos-duration="900"
              ></span>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
export default Roadmap;
